import API from "../api";
import COMMON_API from "@/api/common";

let refCount = 1;

const dummyCompany = {
  id: "9e8cdc8a-7994-44b0-b283-209fb43fdfed",
  cnpj: "44300104000197",
  razao_social: "Snowman Labs Tecnologia Ltda",
  nome_fantasia: "Snowman Labs",
  subsidiaria: false,
  ativo: true,
  status: { id: "ativo", nome: "Ativo" },
  atividade_principal: {},
  endereco: {},
  balancos: [],
  documentos: []
};

export default {
  namespaced: true,
  state: {
    economicGroup: null,
    economicGroups: { total_count: 0, items: [] },
    company: null,
    companies: { total_count: 0, items: [] },
    creditLimitConsult: null,
    quotations: { total_count: 0, items: [] },
    creditLimitStatuses: [],
    itemsRelationshipContacts: [],
    itemsStrutureCCG: [],
    itemsUsers: [],
    itemsApprovalRules: [],
    itemsPrizeRules: [],
    itemsModality: [],
    itemsCompany: [],
    itemsHistoric: null,
    itemsInsuranceConsultMarket: [],
    coBrokering: null
  },
  mutations: {
    setCoBrokering(state, coBrokering) {
      state.coBrokering = coBrokering;
    },
    setListEconomicGroup(state, list) {
      state.economicGroups = list;
    },
    setListCompanies(state, list) {
      state.companies = list;
    },
    setEconomicGroup(state, economicGroup) {
      const group = {
        ...economicGroup,
        referencia: `#LSP${refCount++}`
      };
      state.economicGroup = group;
    },
    setCompany(state, company) {
      state.company = company;
    },
    setCreditLimitConsult(state, consult) {
      state.creditLimitConsult = consult;
    },
    setQuotations(state, quotation) {
      state.quotations = quotation;
    },
    setCreditLimitStatuses(state, statuses) {
      state.creditLimitStatuses = statuses;
    },
    setItemsRelationshipContacts(state, payload) {
      state.itemsRelationshipContacts = payload;
    },
    setItemsStrutureCCG(state, payload) {
      state.itemsStrutureCCG = payload;
    },
    setItemsUsers(state, payload) {
      state.itemsUsers = payload;
    },
    setItemsApprovalRules(state, payload) {
      state.itemsApprovalRules = payload;
    },
    setItemsPrizeRules(state, payload) {
      state.itemsPrizeRules = payload;
    },
    setItemsModality(state, payload) {
      state.itemsModality = payload;
    },
    setItemsCompany(state, payload) {
      state.itemsCompany = payload;
    },
    setItemsHistoric(state, payload) {
      state.itemsHistoric = payload;
    },
    setInsuranceConsultMarket(state, payload) {
      state.itemsInsuranceConsultMarket = payload;
    }
  },
  getters: {
    coBrokering: (state) => (economicGroup, creditLimitId) => {
      if(state.coBrokering != null && economicGroup == state.coBrokering.grupo_economico && creditLimitId == state.coBrokering.limite_credito) {
        return state.coBrokering;
      }
      
      return null;
    }
  },
  actions: {
    setCoBrokering({ commit }, coBrokering) {
      commit('setCoBrokering', coBrokering);
    },
    async fetchCoBrokering({ commit, state }, { grupo_economico, limite_credito }) {
      if(
        state.coBrokering != null &&
        state.coBrokering.grupo_economico == grupo_economico && 
        state.coBrokering.limite_credito == limite_credito) 
      {
        return state.coBrokering;
      }
      else {
        let { data } = await API.fetchCoBrokering(grupo_economico, limite_credito);

        if(data.length == 0) {
          data = {
            ativo: false,
            items: [
              {
                corretora: { value: "" },
                participacao: 50
              },
              {
                corretora: { value: "" },
                participacao: 50
              },
            ],
            limite_credito: limite_credito,
            grupo_economico: grupo_economico
          };
        }
        else {
          let result = {
            ativo: true,
            items: [],
            limite_credito: limite_credito,
            grupo_economico: grupo_economico
          };
          
          for(let i = 0; i < data.length; i++) {
            result.items.push({
              corretora: { value: data[i].corretora_id },
              participacao: data[i].percentagem_participacao
            });
          }

          data = result;
        }

        commit("setCoBrokering", data);
        return data;
      }
    },
    async listEconomicGroups({ commit }, filter) {
      const { data } = await API.listEconomicGroups(filter);
      commit("setListEconomicGroup", data);
      return data;
    },
    async listCompanies({ commit }, { groupId, filter }) {
      const { data } = await API.listCompanies(groupId, filter);
      commit("setListCompanies", data);
      return data;
    },
    async findEconomicGroup({ commit }, groupId) {
      const { data } = await API.findEconomicGroup(groupId);
      commit("setEconomicGroup", data);
      return data;
    },
    async findLegalPerson(context, cnpj) {
      const { data } = await COMMON_API.getPersonByCnpj(cnpj);
      return data;
    },
    async findCEP(context, cep) {
      const response = await COMMON_API.getCEP(cep);
      return response.data;
    },
    async findCNAE(context, code) {
      const response = await COMMON_API.getCNAE(code);
      return response.data;
    },
    async findCompany({ commit }, { groupId, companyId }) {
      let data = dummyCompany;
      try {
        const response = await API.findCompany(groupId, companyId);
        data = response.data;
      } catch (e) {
        process.env.NODE_ENV === "production" && console.error(e);
        return Promise.reject(e);
      }
      commit("setCompany", data);
      return data;
    },
    async findCreditLimitConsult({ commit }, { groupId, consultId }) {
      const { data } = await API.findCreditLimitConsult(groupId, consultId);
      commit("setCreditLimitConsult", data);
      return data;
    },
    async createEconomicGroup(context, economicGroup) {
      const { data } = await API.createEconomicGroup(economicGroup);
      return data;
    },
    async createCompany(context, { groupId, info }) {
      let data = info;
      try {
        const response = await API.createCompany(groupId, info);
        data = response.data;
      } catch (e) {
        process.env.NODE_ENV === "production" && console.error(e);
        return Promise.reject(e);
      }
      return data;
    },
    async createCreditLimitConsult(context, { groupId, info }) {
      const { data } = await API.createCreditLimitConsult(groupId, info);
      return data;
    },
    async updateEconomicGroup(context, { groupId, info }) {
      try {
        const { data } = await API.updateEconomicGroup(groupId, info);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async updateCompany(context, { groupId, companyId, info }) {
      try {
        const { data } = await API.updateCompany(groupId, companyId, info);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async selectEconomicGroup({ commit }, economicGroup) {
      commit("setEconomicGroup", economicGroup);
      return economicGroup;
    },
    async selectCompany({ commit }, company) {
      const data = {
        ...company,
        endereco: {}
      };
      commit("setCompany", data);
      return data;
    },
    async selectCreditLimitConsult({ commit }, consult) {
      commit("setCreditLimitConsult", consult);
      return consult;
    },
    async listInsurerQuotations({ commit }, filter) {
      const { data } = await API.listQuotationsByInsurer(filter);
      commit("setQuotations", data);
      return data;
    },
    async listQuotationsOfEconomicGroup({ commit }, { groupId, filter }) {
      const { data } = await API.listQuotationsOfEconomicGroup(groupId, filter);
      commit("setQuotations", data);
      return data;
    },
    async listCreditLimitStatuses({ commit }) {
      const { data } = await API.creditLimitStatuses();
      commit("setCreditLimitStatuses", data);
      return data;
    },
    async balanceDocumentsOfEconomicGroup(context, { groupId, filter }) {
      const { data } = await API.balanceDocumentsOfEconomicGroup(
        groupId,
        filter
      );
      return data;
    },
    async otherDocumentsOfEconomicGroup(context, { groupId, filter }) {
      const { data } = await API.otherDocumentsOfEconomicGroup(groupId, filter);
      return data;
    },
    async updateCreditLimit(context, { groupId, consultId, payload }) {
      const { data } = await API.updateCreditLimit(groupId, consultId, payload);
      return data;
    },
    async requestRelationshipContacts({ commit }, payload) {
      const { data } = await API.getRelationshipContacts(payload);
      commit("setItemsRelationshipContacts", data);
      return data;
    },
    async requestUploadLogo(context, payload) {
      const { data } = await API.uploadLogo(payload);
      return data;
    },
    async requestStrutureCCG({ commit }) {
      const { data } = await API.getStrutureCCG();
      commit("setItemsStrutureCCG", data);
      return data;
    },
    async requestSuggestUsers({ commit }, payload) {
      const { data } = await COMMON_API.suggestUsers(payload);
      commit("setItemsUsers", data);
      return data;
    },
    async requestApprovalRules({ commit }) {
      const { data } = await API.getApprovalRules();
      commit("setItemsApprovalRules", data);
      return data;
    },
    async requestPrizeRules({ commit }) {
      const { data } = await API.getPrizeRules();
      commit("setItemsPrizeRules", data);
      return data;
    },
    async requestModalityAccordingInsurance({ commit }, payload) {
      const { data } = await API.getModalityAccordingInsurance(payload);
      commit("setItemsModality", data);
      return data;
    },
    async requestCompaniesAccordingEconomicGroup({ commit }, payload) {
      const { data } = await API.getCompaniesAccordingEconomicGroup(payload);
      commit("setItemsCompany", data);
      return data;
    },
    async requestHistoricLimit({ commit }, { groupId, insurance }) {
      const { data } = await API.getHistoricLimit(groupId, insurance);
      commit("setItemsHistoric", data);
      return data;
    },
    async renewCreditLimit(context, { groupId, consultId, payload }) {
      const { data } = await API.renewCreditLimit(groupId, consultId, payload);
      return data;
    },
    async requestInsuranceConsultMarket({ commit }, payload) {
      const { data } = await API.getInsuranceConsultMarket(payload);
      commit("setInsuranceConsultMarket", data);
      return data;
    },
    async requestOffices() {
      const { data } = await API.getOffices();
      return data;
    }
  }
};
